<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="产品名称"><el-input size="small" v-model="searchForm.product_name" placeholder="请输入产品名称"></el-input></el-form-item>
        <el-form-item label="配送方式">
          <el-select size="small" v-model="searchForm.style_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in exStyle" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店列表">
          <el-select size="small" v-model="searchForm.store_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in shopList" :key="index" :label="item.store_name" :value="item.store_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="物流中心" v-if="is_open_logistics">
          <el-select size="small" v-model="searchForm.logistics_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in logisticsList" :key="index" :label="item.name" :value="item.logistics_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
         <el-form-item label="导出方式">
          <el-select size="small" v-model="searchForm.export_type" placeholder="请选择">
            <el-option label="按订单" value=""></el-option>
            <el-option label="按产品" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button size="small" type="warning" @click="showBatchDelivery" v-auth="'/order/order/operate/batchDelivery'">批量发货</el-button>
        </el-form-item>

        <el-form-item><el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit"  v-auth="'/order/order/operate/search'">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport"  v-auth="'/order/order/operate/export'">导出</el-button></el-form-item>
        <el-form-item><el-button size="small" type="primary" @click="importOrder"  v-auth="'/order/order/operate/import'">导入</el-button></el-form-item>
      </el-form>

      <div>
    <order-select-dialog 
      ref="orderDialog"
      v-if="userRole==='supply'"
      @confirm="handleOrderConfirm"
    ></order-select-dialog>
    
    <!-- 显示选择结果 -->
    <!-- <div v-if="selectedOrders.length > 0" class="result-container">
      <h3>已选订单 ({{ mergeInfo.isMerge ? '拼柜' : '不拼柜' }})</h3>
      <div v-if="mergeInfo.isMerge" class="merge-info">
        拼柜立方数: {{ mergeInfo.mergeVolume }}m³
        <span v-if="mergeInfo.remark"> - 备注: {{ mergeInfo.remark }}</span>
      </div>
      
      <el-table :data="selectedOrders" border style="width: 100%">
        <el-table-column prop="orderNo" label="订单号"></el-table-column>
        <el-table-column prop="customerName" label="客户名称"></el-table-column>
        <el-table-column prop="productName" label="产品名称"></el-table-column>
        <el-table-column prop="quantity" label="数量" width="100" align="center"></el-table-column>
        <el-table-column prop="volume" label="体积(m³)" width="120" align="center"></el-table-column>
      </el-table>
    </div> -->
  </div>

    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="userRole != 'ft'">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'待处理(' + order_count. payshipping+ ')'" name="payshipping"></el-tab-pane>
          <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane :label="'已付款(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
        </el-tabs>

        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="userRole === 'ft'">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未接收'" name='naccept'></el-tab-pane>
          <el-tab-pane :label="'已接受'" name='yaccept'></el-tab-pane>
          <el-tab-pane label="已拒绝" name='na'></el-tab-pane>
        </el-tabs>
        

        <el-table
    :data="filteredData"
    style="width: 100%"
    @cell-click="handleCellClick"
  >

    <el-table-column prop="order_no" label="订单编号" width="180"></el-table-column>

    <el-table-column prop="create_time" label="下单时间" width="150"></el-table-column>

    <el-table-column label="购买商品" width="220">
      <template #default="{ row }">
        <div v-for="(product, index) in row.products.slice(0,2)" :key="index">
          {{ product.productInfo.product_name }} × {{ product.num }}
          <el-tag v-if="row.products.length > 2 && index === 1" size="mini">
            等{{ row.products.length - 2 }}件商品
          </el-tag>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="出货方式" width="120">
  <template #default="{ row }">
    <el-tag 
      :type="row.gz_type === 1 ? 'success' : 'warning'"
      size="small"
    >
      {{ row.gz_type === 1 ? '拼柜' : '整柜' }}
    </el-tag>
  </template>
</el-table-column>

    <el-table-column label="状态" width="120">  
  <template #default="{ row }">
    <el-tag 
      v-if="userRole === 'ft'"
    :type="getStatusType(row.status)"
      size="small"
    >
      {{ getacceptText(row.hy_accept) }}
    </el-tag>
    <el-tag 
      :type="getStatusType(row.status)"
       v-if="userRole != 'ft'"
      size="small"
    >
      {{ getStatusText(row.status) }}
    </el-tag>
  </template>
</el-table-column>

<el-table-column prop="total_freight_cost" label="运费" width="180"></el-table-column>


    <!-- <el-table-column label="商家" width="99">
      <template #default="{ row }">
        {{ row.supplier.name }}
      </template>
    </el-table-column> -->

    <!-- <el-table-column label="拼柜/海运费" width="125">
      <template #default="{ row }">
        <div class="combined-input">
          <el-input
        v-if="row.gz_type === 1"
        v-model="row.ccabinet_price"
        placeholder="拼柜费"
        size="mini"
        @blur="savePrice(row, 'ccabinet_price')"
      ></el-input>
          <el-input
           v-if="row.gz_type === 1"
            v-model="row.of_price"
            placeholder="海运费"
            size="mini"
            @blur="savePrice(row, 'of_price')"
          ></el-input>
        </div>
      </template>
    </el-table-column> -->

    <el-table-column label="操作" width="299">
  <template #default="{ row }">
    <div class="action-buttons">
      <el-button 
        type="primary" 
        size="mini"
        @click="viewDetail(row)"
      >查看详情</el-button>

      <el-button 
    type="primary" 
    v-if="userRole === 'ft' && row.hy_accept === 0"
    size="mini"
    @click="handleReject"
    :loading="rejectLoading"
  >拒绝</el-button>

  <!-- 接收按钮 -->
  <el-button 
    type="primary"
    v-if="userRole === 'ft' && row.hy_accept === 0" 
    size="mini"
    @click="handleAccept"
    :loading="acceptLoading"
  >接收</el-button>

      <el-button 
       type="primary" 
       v-if="row.status === 1"
        size="mini"
        :disabled="row.status === 4" 
        @click="deliverystatus(row)"
      >商品出库</el-button>
    </div>
  </template>
</el-table-column>
  </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="批量发货说明" :visible.sync="dialogBatchDelivery" width="30%">
      <div>1、先按未发货条件筛选后，导出订单</div>
      <div>2、在导出excel中填写物流公司、物流单号，然后点批量发货导入填好的excel文件</div>
      <div>3、请检查物流公司是否已经添加到系统，<el-link type="primary" :underline="false" @click="gotoExpress()">查看</el-link>
      </div>
      <div style="padding-top: 20px;padding-bottom: 20px;text-align: center;">
        <el-upload class="avatar-uploader" ref="upload" action="string"
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                   :before-upload="onBeforeUploadImage" :http-request="uploadImage" :show-file-list="false">
          <el-button size="small" icon="el-icon-upload" type="primary">上传发货表格</el-button>
        </el-upload>
      </div>
    </el-dialog>

    <!-- 上传导入组件  -->
    <Upload v-if="open_upload" @closeDialog="closeDialogFunc($event,'upload')"></Upload>

  </div>
</template>

<script>
import OrderApi from '@/api/order.js'
import OrderSelectDialog from '@/components/order/OrderSelectDialog.vue';
import Upload from '@/components/file/import'
import qs from 'qs'
import clip from '@/utils/clipboard'
const config = require('../../../../config');  // 根据项目路径调整
export default {
  components:{
    Upload,OrderSelectDialog
  },
  data() {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        product_name:"",
        export_type:'',
        order_no: '',
        style_id: '',
        store_id: '',
        create_time: ''
      },
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /* 物流中心 */
      logisticsList:[],
      /* 是否开启物流中心 */
      is_open_logistics:false,
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        yaccept:0,
        naccept:0,
        payshipping:0,
      },
      supply_id:0,
      supply:{},
       open_upload:false,
      // 导入类型
      import_type:'order',
      dialogBatchDelivery: false,
      data: [], // 从接口获取的数据
      currentEditRow: null,
      dialogVisible:false,
      websocket: null,
      selectedOrders: [],
      filteredData:[],
      userRole:'',
      rejectLoading: false, // 拒绝按钮加载状态
      acceptLoading: false, // 接收按钮加载状态
      currentRowData: null,  // 当前行数据（根据实际情况获取）
      mergeInfo: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
    this.getUser();
  },
  mounted() {
    // 添加全局点击监听
    document.addEventListener('click', this.handleGlobalClick);
  },
  beforeDestroy() {
     this.closeWebSocket();
    // 移除监听
    if (this.websocket) {
      this.websocket.close();
    }
  },
  methods: {
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },

    async handleReject() {
      try {
        this.rejectLoading = true;
        
        const res = await OrderApi.updateShippingInfo({
          "hy_accept":2
        });
        
        this.$message.success('已拒绝');
        this.$emit('rejected', this.currentRowData); // 触发父组件事件
        
      } catch (error) {
        console.error('拒绝失败:', error);
        this.$message.error('拒绝操作失败');
      } finally {
        this.rejectLoading = false;
      }
    },

    // 接收操作
    async handleAccept() {
      try {
        this.acceptLoading = true;
        
        // 这里添加实际的接收逻辑，例如API调用
        const res = await OrderApi.updateShippingInfo({
          "hy_accept":1
        });
        
        this.$message.success('已接收');
        this.$emit('accepted', this.currentRowData); // 触发父组件事件
        
      } catch (error) {
        console.error('接收失败:', error);
        this.$message.error('接收操作失败');
      } finally {
        this.acceptLoading = false;
      }
    },
  
    getUser(){
      OrderApi.getUser().then((res)=>{
        console.log(res.data);
        this.userRole = res.data
        localStorage.setItem('role', JSON.stringify(res.data));
      })
    },
    // 初始化 WebSocket 连接
    initWebSocket() {
  return new Promise((resolve, reject) => {
    // 如果已有连接且状态为 OPEN/CONNECTING，直接复用
    if (this.websocket && [WebSocket.OPEN, WebSocket.CONNECTING].includes(this.websocket.readyState)) {
      resolve();
      return;
    }

    const wsUrl = config.dev.socket;
    this.websocket = new WebSocket(wsUrl);

    this.websocket.onopen = () => {
      console.log('WebSocket 连接已建立');
      resolve(); // 连接成功时解析Promise
    };

    this.websocket.onerror = (error) => {
      console.error('WebSocket 错误:', error);
      reject(error); // 连接失败时拒绝Promise
    };

    this.websocket.onclose = () => {
      console.log('WebSocket 连接已关闭');
    };
  });
},

    // 认证示例（如需）
    authenticate() {
      const token = localStorage.getItem('auth_token');
      this.sendMessage({
        type: 'auth',
        token: token
      });
    },

    handleOrderConfirm(data) {
      this.selectedOrders = data.orders;
      this.mergeInfo = data.mergeInfo;
      
      // 这里可以调用API提交数据
      console.log('选择的订单:', data.orders);
      console.log('拼柜信息:', data.mergeInfo);
    },
    
    // 如果需要手动打开弹窗
    openOrderDialog() {
      this.$refs.orderDialog.showDialog();
    },

    // 处理接收消息
    handleMessage(msg) {
      switch (msg.type) {
        case 'notification':
          this.$notify({ message: msg.content });
          break;
        case 'dataUpdate':
          this.$store.commit('updateData', msg.payload);
          break;
        default:
          console.log('Unknown message type:', msg);
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },
    // 获取状态文本
  getStatusText(status) {
    const statusMap = {
      0: '待入库',
      1: '已入库',
      2: '已出库',
      3: '已收货',
      4: '已取消'
    }
    return statusMap[status] || '未知状态'
  },
  getacceptText(status) {
    const statusMap = {
      0: '未接收',
      1: '已接收',
      2: '已拒绝',
    }
    return statusMap[status] || '未知状态'
  },

  // 获取状态标签类型
  getStatusType(status) {
    const typeMap = {
      0: 'info',     // 待入库-蓝色
      1: '',         // 已入库-默认
      2: 'warning',  // 已出库-橙色
      3: 'success',  // 已收货-绿色
      4: 'danger'    // 已取消-红色
    }
    return typeMap[status]
  },

   async handleDelete(row) {
    try {
      await this.$confirm(`确定要执行此操作吗`,{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      let data = {
      shipping_id: row.shipping_id,
      pay_status: 1
    }
      const res =  OrderApi.updateShippingInfo(data) ;
      await this.initWebSocket();
    
    if (this.websocket.readyState !== WebSocket.OPEN) {
      this.$message.warning('连接尚未建立，请稍后重试');
      return;
    }
    const mid = 'm' + Math.random().toString(36).substring(2);
    const send_type = 3
    const user = await OrderApi.getuserId({ supply_id: row.supply_id });
    const userid = user.data.detail.user_id;
   
    var message = {
        user_id: 1,
        type: 'chat',
        msgtype: 'system_tip1',
        content: row.shipping_id,
        mid: mid,
        to_user_id:userid,
        obj: JSON.stringify({ type: send_type,users:[userid]})
      };
      this.websocket.send(JSON.stringify(message));
      this.$message.success('系统通知已发送');
      this.loadData()
    } catch (error) {
      if (error !== 'cancel') {
        this.$message.error(error.message || '失败');
      }
    }
  },
  
  // 加载数据方法示例
  async loadData() {
    try {
      const res = await this.$api.getOrderList();
      this.data = res.data;
    } catch (error) {
      this.$message.error('数据加载失败');
    }
  },

  deliverystatus(row){
    OrderApi.updateShippingStatusByOrderNo({
            order_no: row.order_no,
          }
        ).then(data => {
          console.log(data);
          this.$message.success("已完成");
        })
  },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
      this.filterData(tab.name);
    },

    /*获取列表*/
    getData() {
      OrderApi.shippinglist()
        .then(res => {
          this.data = res.data.data;
          console.log("table", this.data);
          this.filterData(this.activeName);
        })
        .catch(error => {});
    },

    calculateCounts() {
      this.order_count = {
        yaccept: this.data.filter(item => item.hy_accept === 1).length,
        naccept: this.data.filter(item => item.hy_accept === 0).length,
      };
    },
    
    /* 根据状态过滤数据 */
    filterData(status) {
      
  switch(status) {
    case 'all':
      this.filteredData = this.data;
      break;
    case 'naccept':
      this.filteredData = this.data.filter(item => item.hy_accept === 0);
      break;
    case 'yaccept': 
      this.filteredData = this.data.filter(item => item.hy_accept === 1);
      break;
    case 'payshipping':
      this.filteredData = this.data.filter(item => 
        item.status === 0 && item.pay_status === 0
      );
      break;
    case 'payment':
      this.filteredData = this.data.filter(item => 
         item.pay_status === 1
      );
      break;  
    case 'delivery': 
      this.filteredData = this.data.filter(item => item.pay_status === 2);
      break;
    case 'six': 
      this.filteredData = this.data.filter(item => item.status === 3);
      break;
    default:
      this.filteredData = this.data.filter(item => item.hy_accept === 2);
  }
},

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          order_id: params
        }
      });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    },
    // 商品导入
    importOrder:function(row){
      this.open_upload = true
    },
    createShipping(){

    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
        if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }
    },
    // 显示批量发货说明
    showBatchDelivery() {
      this.dialogBatchDelivery = true;
    },
    /*跳转物流公司*/
    gotoExpress() {
      let self = this;
      self.$router.push('/setting/express/index');
    },

    /*选择图片之前*/
    onBeforeUploadImage(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isEXCEL = fileType === 'xlsx';
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isEXCEL) {
        this.$message.error('上传文件只能是excel格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isEXCEL && isLt10M;
    },

    async savePrice(row, field) {
      console.log(row);
      console.log("field",field);
      try {
        let data = {
          shipping_id: row.shipping_id,
          pay_status: 0,
          [field]: Number(row[field]) 
    }
      const res =  OrderApi.updateShippingInfo(data) ;
        this.$message.success('保存成功');
      } catch (error) {
        this.$message.error('保存失败');
      }
    },

    // 查看详情
    viewDetail(row) {
      let self = this;
      let params = row.shipping_id;
      self.$router.push({
        path: '/order/order/shippingdetail',
        query: {
          shipping_id: params
        }
      });
    },

    // 全局点击处理
    handleGlobalClick(e) {
      if (!e.target.closest('.el-input')) {
        this.saveCurrentEdit();
      }
    },

    // 保存当前编辑
    saveCurrentEdit() {
      if (this.currentEditRow) {
        this.savePrice(this.currentEditRow.row, this.currentEditRow.field);
        this.currentEditRow = null;
      }
    },

    // 单元格点击处理
    handleCellClick(row, column, cell, event) {
      if (column.label === '拼柜/海运费') {
        this.currentEditRow = { row, field: column.property };
      }
    },

    /*上传图片*/
    uploadImage(param) {
      let self = this;
      const loading = this.$loading({
        lock: true,
        text: '正在处理,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let formData = new FormData();
      formData.append('iFile', param.file);
      OrderApi.batchDelivery(formData)
        .then(response => {
          loading.close();
          self.dialogBatchDelivery = false;
          self.$message({
            message: response.msg,
            type: 'warning'
          });
        })
        .catch(response => {
          loading.close();
          self.$message({
            message: '本次处理失败',
            type: 'warning'
          });
          param.onError();
        });
    },

    handleCopy(text, event) {
      clip(text, event)
    },

  }
};
</script>
<style lang="scss" scoped>
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.action-buttons {
  display: flex;
  gap: 8px; /* 按钮间距 */
  flex-wrap: wrap; /* 小屏幕换行 */
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red{ background: red;}
.table-wrap .product-info:first-of-type {
  border-top: none;
}

.result-container {
  margin-top: 20px;
}

.merge-info {
  margin: 10px 0;
  font-size: 14px;
  color: #666;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/shipping.vue